import React, {useEffect, useState, useContext} from 'react'
import { withRouter } from "../../../../helpers/withRouter";
import { getUserByIdPromise } from '../../../Stakeholder/promises';
import { ModalClientCard } from '..';
import { globalContext } from '../../../../contexts';

const ModalRecord = ({match}) => {
    const { currentUser } = useContext(globalContext)
    const [item, setItem] = useState(null);
    
    useEffect(() => {
        if(currentUser?.id) {
            getUserByIdPromise(match.params.clientId, match.params.id).then(response => {
                setItem(response.data.record);
            });
        }

    }, [currentUser]);

    return (
        <div style={{backgroundColor:'white'}} className='show-pdf modal-fichaCliente-register'>
           { item && currentUser &&
                <ModalClientCard 
                    key={item.id}
                    item={item}
                    currentUser={currentUser}
                    showPdf={true}
                />
           }
        </div>
    )
}

export default withRouter(ModalRecord);